<template>
  <div class="software-page">
    <div style="margin-bottom: 16px">
      <datetime-range
        :allow-clear="false"
        :default-value="datetimeRange"
        @ok="
          v => {
            datetimeRange = v
          }
        "
      ></datetime-range>
    </div>
    <a-row :gutter="16">
      <a-col
        v-for="item in monitorItems"
        :key="item.key"
        :span="12"
        style="margin-bottom: 16px;"
      >
        <monitor-chart-card
          :datetime-range="datetimeRange"
          :history-func="historyFunc"
          :item="item"
          :source-id="detail.id"
        ></monitor-chart-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import moment from 'moment'
import { getNetworkDeviceMonitorHistory } from '@/api/network-device'
import DatetimeRange from '@/components/DatetimeRange'
import MonitorChartCard from '@/components/card/MonitorChartCard'

export default {
  name: 'SoftwarePage',
  components: {
    DatetimeRange,
    MonitorChartCard
  },
  props: {
    detail: {
      type: Object
    }
  },
  data () {
    return {
      datetimeRange: [moment().subtract(6, 'hour'), moment()],
      historyFunc: getNetworkDeviceMonitorHistory,
      monitorItems: [
        {
          key: 'icmpping',
          title: 'ICMP Ping'
        },
        {
          key: 'icmppingloss',
          title: 'ICMP Ping 丢包率'
        },
        {
          key: 'icmppingsec',
          title: 'ICMP Ping 延迟'
        }
      ]
    }
  }
}
</script>

<style lang="less">
.software-page {
  padding: 0 4px;
  .module-container {
    position: relative;
    background: #fff;
    border-radius: 6px;
    padding: 16px 16px 8px 16px;
    margin-right: 1px;
    overflow: hidden;
    border: 1px solid #e5e5e5;

    header {
      font-size: 16px;
      font-weight: 500;
      color: #096dd9;
      line-height: 22px;
    }

    .ant-descriptions-item-content {
      font-size: 14px;
    }
  }
}
</style>
